<template>
  <div class="mb-xl-0 pb-5" :style="`background-color: #f9f9f9;`">
    <div ref="observerTimeDesk"></div>
    <div class="container pt-4 conheca-time mb-3 mb-xl-0" v-if="posts">
      <div class="row">
        <div class="col-12">
          <h2
            class="font-glacial-bold text-left text-lowercase text-xl-left text-center mb-md-5 font-size-know-team mt-md-3"
          >
            {{ data.titulo }}
          </h2>
        </div>
      </div>
      <transition enter-active-class="animated fadeInUp">
        <div
          class="row mt-4 mb-0 pb-0 d-none d-xl-flex"
          v-if="data && showObserverDesk"
        >
          <div
            class="col-12 col-md-6 col-lg-4 mb-4 pb-2"
            v-for="(d, i) in time"
            :key="i"
          >
            <div class="border-transparent border-radius-0 pr-xl-0 pr-md-3">
              <div
                class="card-body card text-white card-time p-0 border-0 border-radius-0 height-mobile"
                :style="`background-image: url(${d.better_featured_image.source_url})`"
                @touchstart="show = i"
                @touchend="show = -1"
                @mouseover="show = i"
                @mouseleave="show = -1"
              >
                <div
                  class="row no-gutters h-100 w-100 align-items-center"
                  v-if="show == i"
                >
                  <div class="col-12 align-self-center text-center pt-3 mt-5">
                    <h2 class="font-glacial-bold">
                      {{ d.acf.nome }}
                    </h2>
                    <h3 class="font-glacial-regular text-uppercase mb-4 pb-4">
                      {{ d.acf.cargo }}
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div class="container-fluid d-block d-xl-none">
      <div class="row justify-content-center mb-xl-5 pb-4 pb-xl-0 mb-0">
        <div ref="observerTime"></div>
        <transition enter-active-class="animated fadeInUp">
          <div class="col-xl-12 col-10" v-if="showObserver">
            <slick
              ref="slick"
              class="eventos know-team"
              :options="slickOptions"
              v-if="data && time"
            >
              <div
                style="padding: 0 5px"
                class="border-transparent border-radius-0 pr-xl-0 pr-md-3 ml-md-1 px-3 px-lg-0"
                v-for="(d, i) in posts"
                :key="i + 'f'"
                @click="routeTo({ name: 'autor', params: { name: d.slug } })"
              >
                <div
                  class="card-body card text-white card-time-mobile p-0 border-0 border-radius-0 height-mobile"
                  :style="'background-image: url(' + d.foto.sizes.medium + ')'"
                  @touchstart="show = i"
                  @touchend="show = -1"
                  @mouseover="show = i"
                  @mouseleave="show = -1"
                >
                  <div
                    class="row no-gutters h-100 w-100 align-items-center justify-content-center"
                    v-if="false"
                  >
                    <div
                      class="col-12 align-self-center text-center pt-xl-0 mt-xl-0 pt-3 mt-5"
                    >
                      <h3 class="font-glacial-bold">
                        {{ d.acf.nome }}
                      </h3>
                      <h5 class="font-glacial-regular text-uppercase mb-0 pb-0">
                        {{ d.acf.cargo }}
                      </h5>
                    </div>

                    <a :href="d.facebook" target="_blank">
                      <img
                        class="icon-team-personal-fb mb-3 mx-2"
                        @mouseenter="changeIcon('fb')"
                        @mouseleave="activeIcon = false"
                        :src="fbpath"
                      />
                    </a>
                    <a :href="d.twitter" target="_blank">
                      <img
                        class="icon-team-personal-twitter mb-3 mx-2"
                        @mouseenter="changeIcon('twitter')"
                        @mouseleave="activeIcon = false"
                        :src="twitterpath"
                      />
                    </a>
                    <a :href="d.instagram" target="_blank">
                      <img
                        class="icon-team-personal-insta mb-3 mx-2"
                        @mouseenter="changeIcon('insta')"
                        @mouseleave="activeIcon = false"
                        :src="instapath"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </slick>
          </div>
        </transition>
      </div>
    </div>

    <div
      class="d-flex d-xl-flex justify-content-center pb-0 pb-sm-3 pt-4 pt-xl-0 pb-0"
      v-if="$route.name == 'Home'"
    >
      <b-button
        variant="ver-todos"
        class="col-xl-2 mb-3 mt-xl-1 mt-3 btn-opacidade"
        to="/bauhaus"
      ></b-button>
    </div>

    <div class="slider-fullwidth-mobile" v-else-if="$route.path == '/bauhaus'">
      <div class="row d-flex justify-content-center mt-3">
        <b-button
          v-if="indexData < total"
          variant="ver-mais"
          @click="postsSliced"
          :disabled="loading"
          class="btn-opacidade"
        ></b-button>
      </div>
    </div>
  </div>
</template>

<script>
import observer from "intersection-observer";

export default {
  props: {
    data: null,
  },

  data() {
    return {
      activeIcon: false,
      loading: false,
      showObserver: false,
      showObserverDesk: false,
      time: null,

      show: -1,
      total: 0,
      indexData: 3,
      page: 1,
      posts: null,

      slickOptions: {
        arrows: true,
        slidesToShow: 2,
        infinite: false,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
            },
          },
        ],

        // Any other options that can be got from plugin documentation
      },
    };
  },

  created() {
    // this.loadMore();
    // this.postsSliced()
    this.loadMore();
  },

  mounted() {
    var observerDesk = new IntersectionObserver((entries) => {
      // If intersectionRatio is 0, the target is out of view
      // and we do not need to do anything.
      if (entries[0].intersectionRatio <= 0) {
        return;
      }
      // this.loadPosts()
      this.showObserverDesk = true;
      observerDesk.unobserve(this.$refs.observerTimeDesk);
    });
    observerDesk.observe(this.$refs.observerTimeDesk);

    var observerTime = new IntersectionObserver((entries) => {
      // If intersectionRatio is 0, the target is out of view
      // and we do not need to do anything.
      if (entries[0].intersectionRatio <= 0) {
        return;
      }

      this.showObserver = true;
      observerTime.unobserve(this.$refs.observerTime);
    });

    observerTime.POLL_INTERVAL = 100;
    observerTime.observe(this.$refs.observerTime);
  },

  // All slick methods can be used too, example here
  methods: {
    loadMore() {
      var url =
        window.SETTINGS.API_BASE_PATH +
        `posts?_embed&categories=24&order_by=rand&per_page=100`;

      axios.get(url).then((response) => {
        this.total = parseInt(response.headers["x-wp-total"]);
        this.posts = this.shuffle(response.data);
        console.log('posts', this.posts);
        this.time = this.posts.slice(0, this.indexData);
      });
    },

    removeAcento(text) {
      text = text.replace(new RegExp("[ÁÀÂÃ]", "gi"), "a");
      text = text.replace(new RegExp("[ÉÈÊ]", "gi"), "e");
      text = text.replace(new RegExp("[ÍÌÎ]", "gi"), "i");
      text = text.replace(new RegExp("[ÓÒÔÕ]", "gi"), "o");
      text = text.replace(new RegExp("[ÚÙÛ]", "gi"), "u");
      text = text.replace(new RegExp("[Ç]", "gi"), "c");
      return text;
    },

    clicked(data) {
      if (data.link) {
        if (data.link.includes("http:")) {
          window.open(data.link);
        } else {
          window.location.replace(data.link);
        }
      } else {
        if (data.video) {
          this.$store.commit("setVideoId", data.video);
          this.$root.$emit("bv::show::modal", "video-modal");
        }
      }
    },

    routeTo(obj) {
      this.$router.push(obj);
    },

    next() {
      this.$refs.slick.next();
    },

    prev() {
      this.$refs.slick.prev();
    },

    reInit() {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$nextTick(() => {
        this.$refs.slick.reSlick();
      });
    },

    // Events listeners
    async loadImg(url) {
      let img = new Image();
      img.src = url;
    },

    postsSliced() {
      this.indexData = this.indexData + 3;
      this.time = this.posts.slice(0, this.indexData);
      this.page++;

      // this.loadMore()
    },
  },

  computed: {
    fbpath() {
      if (this.activeIcon == "fb") {
        return "/wp-content/themes/rhiza/src/assets/fb_mini.png9";
      } else {
        return "/wp-content/themes/rhiza/src/assets/fb_mini.png";
      }
    },

    twitterpath() {
      if (this.activeIcon == "twitter") {
        return "/wp-content/themes/rhiza/src/assets/twitter-icon.png9";
      } else {
        return "/wp-content/themes/rhiza/src/assets/twitter-icon.png";
      }
    },
    
    instapath() {
      if (this.activeIcon == "insta") {
        return "/wp-content/themes/rhiza/src/assets/insta_icon2.png9";
      } else {
        return "/wp-content/themes/rhiza/src/assets/insta_icon2.png";
      }
    },

    // postsDesk(){
    //     console.log(this.posts.slice(0, 3))
    //     return this.posts.slice(0, 3)
    // },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/widgets/conheca-time.vue